import "bootstrap/dist/css/bootstrap.min.css";
import "core-js";
import React from "react";
import {createRoot} from "react-dom/client";
import "./css/dispatcherUser.css";
import "./css/grit.css";
import "./css/loaders.min.css";
import "./css/tmds.min.css";
import App from "./components/app";
import { registerModal } from "./components/modalConfirm";
import { initialize as initializePollar } from "./components/poller";
import { initializeTimeout } from "./components/timeoutModal";

require("./shim/date");
require("./shim/array");
require("./shim/math");
require("./shim/integer");
require("./stores/session");

//SchematicActions.initialize();
registerModal();
initializePollar();
initializeTimeout();

const root = createRoot(document.getElementById("app"));
root.render(
  <App /> 
);